import React from 'react';
import { Button } from './ui/Button';
import { Scale, FileText } from 'lucide-react';
export function PlayerRightsSection() {
  return <section className="py-20 bg-[#F5F0E8]" data-id="element-197">
      <div className="container mx-auto px-4" data-id="element-198">
        <div className="text-center mb-16" data-id="element-199">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0A5E5C] mb-4" data-id="element-200">
            Права гравців важливі
          </h2>
          <div className="h-1 w-24 bg-[#D4A843] mx-auto rounded-full mb-6" data-id="element-201" />
          <p className="text-gray-600 text-lg max-w-2xl mx-auto" data-id="element-202">
            Знання своїх прав — це перший крок до захисту. Ми надаємо юридичну
            підтримку та консультації.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-203">
          {/* Left Card */}
          <div className="bg-white p-8 md:p-10 rounded-xl shadow-sm border border-gray-100 flex flex-col items-start hover:shadow-md transition-shadow" data-id="element-204">
            <div className="w-14 h-14 bg-[#0A5E5C]/10 rounded-full flex items-center justify-center mb-6" data-id="element-205">
              <Scale className="w-8 h-8 text-[#0A5E5C]" data-id="element-206" />
            </div>
            <h3 className="text-2xl font-serif font-bold text-[#0A5E5C] mb-4" data-id="element-207">
              Знайте свої права
            </h3>
            <ul className="space-y-3 mb-8 text-gray-600 flex-grow" data-id="element-208">
              <li className="flex items-start gap-2" data-id="element-209">
                <span className="text-[#D4A843] font-bold" data-id="element-210">•</span>
                Право на чесну гру та прозорі правила
              </li>
              <li className="flex items-start gap-2" data-id="element-211">
                <span className="text-[#D4A843] font-bold" data-id="element-212">•</span>
                Право на своєчасну виплату виграшів
              </li>
              <li className="flex items-start gap-2" data-id="element-213">
                <span className="text-[#D4A843] font-bold" data-id="element-214">•</span>
                Право на захист персональних даних
              </li>
              <li className="flex items-start gap-2" data-id="element-215">
                <span className="text-[#D4A843] font-bold" data-id="element-216">•</span>
                Право на самообмеження
              </li>
            </ul>
            <Button variant="primary" data-id="element-217">Дізнатися більше</Button>
          </div>

          {/* Right Card */}
          <div className="bg-white p-8 md:p-10 rounded-xl shadow-sm border border-gray-100 flex flex-col items-start hover:shadow-md transition-shadow" data-id="element-218">
            <div className="w-14 h-14 bg-[#D4A843]/10 rounded-full flex items-center justify-center mb-6" data-id="element-219">
              <FileText className="w-8 h-8 text-[#D4A843]" data-id="element-220" />
            </div>
            <h3 className="text-2xl font-serif font-bold text-[#0A5E5C] mb-4" data-id="element-221">
              Подати звернення 
            </h3>
            <p className="text-gray-600 mb-8 leading-relaxed flex-grow" data-id="element-222">
              Якщо Ви зіштовхнулися з порушенням Ваших прав в сфері азартних ігор, 
              Ви можете подати звернення через наш сайт  

            </p>
            <Button variant="secondary" data-id="element-223">Подати скаргу</Button>
          </div>
        </div>
      </div>
    </section>;
}